import { isAuth } from "../utils";
import { isArray, isString, hasIn } from "lodash";

//设置el或vnode
//权限验证
function operation(el, binding, vnode) {
  if (!binding.value || binding.value.length === 0) {
    //传入的长度为0 或者value的值为null\''\undefined
    return true; //返回true
  }
  //判断 binding.value 类型，为Array/String
  if (isString(binding.value)) {
    //根据传入类型判断是否有鉴权成功的

    if (isAuth(binding.value)) {
      //是否鉴权成功
      return true;
    }
  } else if (isArray(binding.value)) {
    //根据传入类型判断是否有鉴权成功的

    let authSuccess = false;
    //遍历数组，看其中是否有鉴权成功的
    binding.value.forEach((element) => {
      if (isAuth(element)) {
        authSuccess = true;
      }
    });
    if (authSuccess) {
      //是否含有鉴权成功的项
      return true;
    }
  } else {
    //类型不是Array或者String则报错
    console.error(`【PLATFORM ERROR】:v-auth 属性需要传入 Array/String 类型数据，但收到的组件类型为${typeof binding.value}。`, binding.value);
    return false;
  }
  if (binding.arg === "visible") {
    //directive 传入参数为visible,指定为显示/隐藏
    el.style.display = "none"; //隐藏
  } else {
    if (vnode.componentInstance && hasIn(vnode.componentInstance, "isAuth")) {
      //判断是否为虚拟DOM实例，并判断其中componentInstance下是否有 disabled 属性
      vnode.componentInstance.isAuth = false;
    } else {
      el.style.display = "none"; //没有虚拟DOM实例或其下没有disabled属性 的全部设置不显示。
    }
  }
}

export const auth = {
  name: "auth",
  bind: operation,
  update: operation,
};
